<div [hidden]="!isSideBarHidden" style="position: relative;">
  <i style="position: fixed;top: 50%;" (click)="isSideBarHidden=false" class="fa fa-arrow-left cursor larger-icon"></i>
</div>
<div class="container-fluid">
  <div class="row min-hieght-2500px display_block">
    <div class="col-md-4" [hidden]="isSideBarHidden">
      <div class="add-section-header" *ngIf="user?.roles==='admin' || empType.includes('Teacher')">
        <div>
          <i [hidden]="isReadMode" class="ft-plus cursor larger-icon"
            (click)="addItem('section', $event, courseId)"  ngbTooltip="add new section" placement="right"></i>
        </div>
        <i *ngIf="user?.roles==='admin' || empType.includes('Teacher')"
          class="ft-layout cursor larger-icon" (click)="gotoMeanderLink(courseData?.slug)" ngbTooltip="goto meander training" placement="right"></i>
        <i *ngIf="user?.roles==='admin' || empType.includes('Teacher')" class="ft-settings cursor larger-icon" (click)="gotoSession(courseId)" ngbTooltip="goto sessions" placement="right"></i>
        <i *ngIf="user?.roles==='admin' || empType.includes('Teacher')"
          [ngClass]="isReadMode?'fa fa-cog cursor larger-icon-read':'fa fa-book cursor larger-icon-read'"
          (click)="openNewTab(courseData?.slug)" ngbTooltip="goto student lms view" placement="right"></i>
          <i class="ft-chevrons-up cursor larger-icon" [ngClass]="{'text-primary':expandAll==true}" (click)="toggleExpandAll(true)"   ngbTooltip="expand view" placement="right"></i>
        <!-- <i class="ft-plus-square cursor larger-icon" (click)="toggleExpandAll(true)"   ngbTooltip="expand view" placement="right"></i> -->
        <!-- <i class="ft-list cursor larger-icon" (click)="toggleExpandAll(false)"  ngbTooltip="collapse view" placement="right"></i> -->
        <i class="ft-chevrons-down cursor larger-icon" [ngClass]="{'text-primary':expandAll==false}" (click)="toggleExpandAll(false)"  ngbTooltip="collapse view" placement="right"></i>
        </div>
      <div>
        <ng-select 
        [items]="flattenedItems" 
        bindLabel="name"
        placeholder="Select"
        (search)="onSearch($event.term)"
        [virtualScroll]="true"
        (keydown.enter)="searchAndGetAppsInACourse()"
      >
      <ng-template ng-option-tmp let-item="item">
        <div class="d-flex flex-column p-2 border rounded mb-2" (click)="selectItemfromSearchList(item)">
          <div class="d-flex justify-content-between align-items-center">
            <ng-container *ngIf="item.category === 'Section'; else otherCategories">
              <strong
                class="text-section flex-grow-1 text-truncate">
                {{ item.name }}
              </strong>
            </ng-container>
            <ng-template #otherCategories>
              <div
                class="flex-grow-1 text-truncate"
                [ngClass]="{
                  'text-chapter': item.category === 'Chapter',
                  'text-topic': item.category === 'Topic'
                }"
              >
                {{ item.name }}
              </div>
            </ng-template>
            <small class="text-muted text-truncate" *ngIf="item.category">{{ item.category }}</small>
          </div>
          
        </div>
      </ng-template>
      
      </ng-select>
    
      </div>
      <div class="list-group" id="items" cdkDropList [cdkDropListData]="sections"
        (cdkDropListDropped)="onDrop($event,'sections')">
        <ul>
          <li class="cursor" *ngFor="let section of sections; let sectionIndex = index" cdkDrag [cdkDragData]="section"
            cdkDropList [cdkDropListData]="section.chapters" (cdkDropListDropped)="onDrop($event,'chapters')">
            <div  class="list-group-item section-list" [ngClass]="{'active-section': activeSectionId==section?._id}">
              <div (click)="activeBreadcrumb(section?.name, section?._id)" data-toggle="collapse"
                [attr.data-target]="'#sectionCollapse' + sectionIndex">
                <div *ngIf="section?.isEditing">
                  <input [(ngModel)]="section.name" (keydown.enter)="editItem($event, 'section', sectionIndex)">
                </div>
                <div class="list-title" *ngIf="!section?.isEditing">
                  {{ section?.name }}
                  <div style="display: flex">
                    <i *ngIf="!isReadMode && user.roles === 'admin' || empType.includes('Teacher')" class="fa fa-edit cursor"
                      (click)="section.isEditing=true"></i>
                    <i *ngIf="!section?.chapters?.length && !isReadMode && user?.roles === 'admin' || empType.includes('Teacher')"
                      class="fa fa-trash cursor"
                      (click)="confirmDelete($event, 'section', section._id, sectionIndex)"></i>
                    <i *ngIf="!isReadMode && user?.roles === 'admin' || empType.includes('Teacher')" class="fa fa-plus-square cursor"
                      (click)="addItem('chapter', $event, section?._id, sectionIndex)"></i>
                    <i *ngIf="section.chapters?.length" class="fa fa-chevron-down cursor"
                      [ngbCollapse]="'#sectionCollapse' + sectionIndex"></i>
                  </div>
                </div>
              </div>
              <ul [id]="'sectionCollapse' + sectionIndex" class="collapse"
              [ngbCollapse]="!(expandAll || section?.collapsed)"
                [class.show]="expandAll || sectionIndex === 0">
                <li class="cursor" *ngFor="let chapter of section?.chapters; let chapterIndex = index" cdkDrag
                  [cdkDragData]="chapter" cdkDropList [cdkDropListData]="chapter.topics"
                  (cdkDropListDropped)="onDrop($event,'topics')">
                  <div class="list-group-item chapter-list"
                    [ngClass]="{'active-chapter': activeChapterId==chapter?._id}">
                    <div (click)="activeBreadcrumb(section?.name, section?._id, chapter?.name, chapter?._id)"
                      data-toggle="collapse"
                      [attr.data-target]="'#chapterCollapse' + sectionIndex + '-' + chapterIndex">
                      <div *ngIf="chapter?.isEditing && (user?.roles === 'admin' || empType.includes('Teacher'))">
                        <input [(ngModel)]="chapter.name"
                          (keydown.enter)="editItem($event, 'chapter', sectionIndex, chapterIndex)">
                      </div>
                      <div class="list-title" *ngIf="!chapter?.isEditing">
                        {{ chapter?.name }}
                        <div style="display: flex">
                          <i *ngIf="!isReadMode && user.roles === 'admin' || empType.includes('Teacher')" class="fa fa-edit cursor"
                            (click)="chapter.isEditing=true"></i>
                          <i *ngIf="!chapter?.topics?.length && !isReadMode && user?.roles === 'admin' || empType.includes('Teacher') "
                            class="fa fa-trash cursor"
                            (click)="confirmDelete($event, 'chapter', chapter._id, sectionIndex, chapterIndex)"></i>
                          <i *ngIf="!isReadMode && user?.roles === 'admin' || empType.includes('Teacher') " class="fa fa-plus-square cursor"
                            (click)="addItem('topic', $event, chapter?._id, sectionIndex, chapterIndex)"></i>
                          <i *ngIf="chapter?.topics?.length" class="fa fa-chevron-down cursor"
                            [ngbCollapse]="'#chapterCollapse' + sectionIndex + '-' + chapterIndex"></i>
                        </div>
                      </div>
                    </div>
                    <ul [id]="'chapterCollapse' + sectionIndex + '-' + chapterIndex" class="collapse"
                    [ngbCollapse]="!(expandAll || chapter?.collapsed)"
                    [class.show]="expandAll || (sectionIndex === 0 && chapterIndex === 0)">
                      <li class="cursor"
                        (click)="getAppsByTopic(topic?._id, chapter.topics); activeBreadcrumb(section?.name, section._id, chapter?.name, chapter._id, topic?.name, topic._id)"
                        *ngFor="let topic of chapter.topics; let topicIndex = index" cdkDrag [cdkDragData]="topic">
                        <div class="list-group-item topic-list" [ngClass]="{'active-topic': activeTopicId==topic?._id}">
                          <div *ngIf="topic?.isEditing">
                            <input [(ngModel)]="topic.name"
                              (keydown.enter)="editItem($event, 'topic', sectionIndex, chapterIndex, topicIndex)">
                          </div>
                          <div class="list-title" *ngIf="!topic?.isEditing">
                            {{ topic.name }}
                            <div style="display: flex">
                              <i *ngIf="user.roles === 'admin' || empType.includes('Teacher')" [hidden]="isReadMode" class="fa fa-edit cursor"
                                (click)="topic.isEditing=true"></i>
                              <i *ngIf="user.roles === 'admin' || empType.includes('Teacher')" [hidden]="isReadMode" class="fa fa-trash cursor"
                                (click)="confirmDelete($event, 'topic', topic?._id, sectionIndex, chapterIndex, topicIndex)"></i>
                            </div>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </li>
              </ul>
            </div>
          </li>
        </ul>
      </div>

    </div>



    <div class="col-md-8 video-container" [ngClass]="{'col-12': isSideBarHidden}">

      <div id="bc_wrapper">
        <h3>{{ courseData?.title }}</h3>
        <span class="section_bc text-capitalize" *ngIf="activeSectionName">&gt;&gt; {{ activeSectionName }}</span>
        <span class="chapter_bc text-capitalize" *ngIf="activeChapterName">&gt;&gt; {{ activeChapterName }}</span>
        <span class="topic_bc blue_c text-capitalize" *ngIf="activeTopicName">&gt;&gt; {{ activeTopicName }}</span>
      </div>
      <app-lms-content *ngIf="topicId && selectedTopics; else elseTemplate" [topics]="selectedTopics" (refreshData)="getAppsByTopic(topicId,selectedTopics)"
        [appsByTopic]="appsByTopic" [isReadMode]="isReadMode" [topicId]="topicId"
        [courseId]="courseId"></app-lms-content>
      <ng-template #elseTemplate>
        <!-- Content to display when the condition is false -->
        <app-lms-content [appsByTopic]="appsByTopic" [isReadMode]="isReadMode"
        [courseId]="courseId"></app-lms-content>
      </ng-template>
    </div>
  </div>
</div>

<!---------- Teacher for Time Update  Modal  ---------------->
<div>
  <ng-template #myModal let-modal>
    <div class="modal-header">
      <h4 class="modal-title">Teach Time</h4>
      <button type="button" class="close" (click)="modal.dismiss()">
        <span>&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <form>
        <div class="form-group">
          <label>Teaching Time</label>
          <input type="datetime-local" class="form-control" [(ngModel)]="teaching_time"
            [ngModelOptions]="{standalone: true}">
        </div>
      </form>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Cancel</button>
      <button type="button" class="btn btn-primary" (click)="submit()">Submit</button>
    </div>
  </ng-template>
</div>
<div class="d-flex justify-content-between align-items-center">
  <ngx-spinner></ngx-spinner>
</div>